/**
 * Domain types for Story AI. Mirrors CONCEPT.md §10.
 *
 * Naming note: the concept doc calls a playthrough a "session". In code it is
 * `PlaySession` (DB: `play_sessions`) to avoid clashing with auth sessions.
 */
export const DEFAULT_FAIL_RULE = {
    mode: "restart_chapter",
    state: "rollback",
};
//# sourceMappingURL=types.js.map